import React from 'react';
import ReloadButton from '../../../../features/ReloadButton/ReloadButton';
// import { useTemplate } from '../../../../features/template/TemplateProvider';
import { addOption, InputFieldSearch, SelectOption } from '../../../../utils/InputField';

function ExternalLogPageHeader({ handleReload, p, onChangeHandler }) {
    // const { setMessage, setConfirm, setTemplateLoading } = useTemplate();

    // const handleDeleteAllExternalLog = () => {
    //     setConfirm({
    //         text: 'Are you sure you want to delete all logs?',
    //         textAction: 'Yes',
    //         clickAction: () => {
    //             setTemplateLoading(true);
    //             ApiExternalLogsDelete()
    //                 .then(({ title }) => {
    //                     setMessage({ type: 'success', text: title });
    //                     setTemplateLoading(false);
    //                     setConfirm(null);
    //                     handleReload();
    //                 })
    //                 .catch((err) => {
    //                     setTemplateLoading(false);
    //                     setMessage({ type: 'error', text: err.toString() });
    //                 });
    //         }
    //     });
    // };

    return (
        <div className="client_page_header w-full mb-7 flex flex-row justify-between items-center">
            <div className="client_page_header_left_col flex-1 flex items-center gap-x-5">
                <InputFieldSearch
                    name="q"
                    formData={p}
                    onChange={onChangeHandler}
                    placeholder="Search..."
                    className="w-76"
                />
            </div>
            <div className="client_page_header_right_col flex items-center gap-x-2">
                <div>
                    <SelectOption
                        placeholder="Limit"
                        name="limit"
                        formData={p}
                        onChange={onChangeHandler}
                        options={[10, 20, 50, 100].map((item) => addOption(item, item, item))}
                        className="w-30"
                    />
                </div>
                <ReloadButton onClick={handleReload} width="w-10" height="h-10" />
            </div>
        </div>
    );
}

export default ExternalLogPageHeader;
